module.exports = __webpack_public_path__ + "img/Xingqi_Chen.91599177.png";